export class Product {
  productid: number;
  product: string;
  productname: string;
  active: number;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  dirpath: string;
  businessunitid: string;
  dtdid: string;
  outputformatid: string;
  xmlcontentarea: string;
  notificationemailid: string;
  externalmailid: string;
}
